import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.less";

const Button = ({ type, onClick, isRtl, isIE }) => {
  return (
    <div className={`${styles.btnWrapper} ${isIE && styles.ieIsShit}`}>
      <button
        className={`${styles.btn} ${styles[type]} ${isRtl && styles.rtl} `}
        onClick={onClick}
        type="button"
      />
    </div>
  );
};

Button.propTypes = {
  isIE: PropTypes.bool,
  isRtl: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Carousel/Button/Button.js